import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { ExhaustiveError } from 'src/util/error'
import { TemplateEditMode } from '../../context/TemplateEditMode/TemplateEditMode'
import { getTemplateSpecificQueryOptions } from './useQueryTemplateSpecificMultipleChoices'

/**
 * ひな形限定の選択肢を削除する
 */
export const useMutationDeleteTemplateSpecificMultipleChoices = (
  templateEditMode: TemplateEditMode,
) => {
  const queryClient = useQueryClient()
  const { queryKey } = getTemplateSpecificQueryOptions(templateEditMode)
  return useMutation({
    mutationFn: async (multipleChoiceId: number): Promise<void> => {
      switch (templateEditMode.mode) {
        case 'edit':
          // 編集モード時はtemplateIdを使用してDELETEリクエストを送信
          return await baseClient
            .getApi(TemplatesApi)
            .deleteTemplateResponseMultipleChoices({
              templateId: templateEditMode.templateId,
              multipleChoiceId,
            })
            .catch(handleHTTPError)
        case 'new':
        case 'newFromPreparedTemplate':
          // 新規作成時は既存のAPI呼び出しを使用
          return await baseClient
            .getApi(TemplatesApi)
            .deleteResponseMultipleChoices({
              multipleChoiceId,
            })
            .catch(handleHTTPError)
        default:
          throw new ExhaustiveError(templateEditMode)
      }
    },
    onSuccess: (_, deletedId) => {
      queryClient.setQueryData<MultipleChoiceGroup[]>(queryKey, (old = []) =>
        old.filter(group => group.id !== deletedId),
      )
    },
  })
}
